import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import React, { useCallback } from 'react';

import { editDataRequestItem } from '../../../services/dealGPT';
import { DataRequestItem } from '../../../Types/dealGPT';
import { DataRequestItemPriority } from '../../../Types/enums';

interface DataRequestItemPrioritySelectProps {
  item: DataRequestItem;
  onItemChanged: (newItem: DataRequestItem) => void;
}

export const DataRequestItemPrioritySelect = ({
  item,
  onItemChanged,
}: DataRequestItemPrioritySelectProps) => {
  const onPriorityChange = useCallback(
    async (e: SelectChangeEvent<DataRequestItemPriority>) => {
      const newValue = e.target.value as DataRequestItemPriority;

      const newItem = await editDataRequestItem(item.projectId, {
        id: item.id,
        priority: newValue,
      });
      onItemChanged(newItem);
    },
    [item.id, item.projectId, onItemChanged]
  );

  return (
    <Select size="small" value={item.priority} onChange={onPriorityChange} sx={{ width: '150px' }}>
      {Object.values(DataRequestItemPriority).map((s) => (
        <MenuItem key={s} value={s}>
          <Typography>{s}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};
